// extracted by mini-css-extract-plugin
module.exports = {"form":"styles_form__zIuqx","row":"styles_row__2nOwf"};